<h1 class="save-line-head">Test Area</h1>
<h4 i18n="@@text-testarea1">
  In quest'area è possibile gestire le configurazioni e le transazioni del merchant in ambiente di test.
</h4>
<h3 class="text-green-bold" i18n="@@subtitle-whatYouCanDo">Cosa puoi fare</h3>
<h4 i18n="@@text-testarea2">
  Creare e simulare un pagamento, visualizzare il riepilogo delle transazioni, configurare i metodi di pagamento, visualizzare le variabili dell'ambiente di test e produzione, generare un token di accesso e scaricare le integrazioni SDK.
</h4>

<!-- ROW 1 -->
<div class="menu-row">
  <a routerLink="transactions" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="crea" class="start-icon"></mat-icon>
        <span class="label" i18n="@@itemMenu-Transaction">Test transazioni</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>

  <a routerLink="transactions-summary" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="elenco" class="start-icon"></mat-icon>
        <span class="label" i18n="@@transaction-summary">Sommario transazioni</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>
</div>

<!-- ROW 2 -->
<div class="menu-row">
  <a routerLink="configuration" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="configurazione" class="start-icon"></mat-icon>
        <span class="label" i18n="@@itemMenu-Configuration">Configurazione</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>

  <a routerLink="downloads" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="download" class="start-icon"></mat-icon>
        <span class="label">Download</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>
</div>
